import { environment } from '../../../environments/environment';

type SitemapEnvironment = {
  AppConfig: { BaseURL?: string };
  FeatureConfig: { id: string; cards: Array<{ id: string }> };
};

export function getRoutePaths(siteEnvironment?: SitemapEnvironment): { home: string; featureDetails: string } {
    return {
      home: '',
      featureDetails: `${(siteEnvironment ? siteEnvironment.FeatureConfig.id : environment.FeatureConfig.id)}/:id`,
    };
}

export function getAllRoutes(siteEnvironment: SitemapEnvironment = environment): string[] {
  if (!siteEnvironment.AppConfig.BaseURL) {
    throw new Error('Cannot generate a sitemap without AppConfig.BaseURL.');
  }

  const baseString = siteEnvironment.AppConfig.BaseURL + '/';
  const featureDetailsPath = getRoutePaths(siteEnvironment).featureDetails;
  const pathStrings: string[] = [baseString + getRoutePaths(siteEnvironment).home];

  siteEnvironment.FeatureConfig.cards.forEach(card => {
    pathStrings.push(baseString + featureDetailsPath.replace(':id', card.id));
  });

  return pathStrings;
}
